import CheckedIcon from "@/assets/svgs/checked-icon";
import RadioIcon from "@/assets/svgs/radio-input-icon";
import { Pressable, Text } from "react-native";
import { useSlot, useStyled } from "use-styled";


const RadioInputRoot = useStyled(Pressable, {
  base: {
    className: "flex-1 flex-row items-center justify-between border border-gray-200 bg-teachLoop-creamLight rounded-[17] px-4 py-3 focus:outline-teal-600 ",
  },
  variants: {
    size: {},
    error: {
      true: { className: "border-red-500" },
      false: {},
    },
    disabled: {
      true: { className: "opacity-50" },
    },
  },
  defaultVariants: {
  },
  compoundVariants: [
    {
      disabled: true,
      props: {
        disabled: true,
      },
    },
  ],
});

const RadioInputLabel = useStyled(Text, {
  base: {
    className: "text-gray-800 font-geologica-regular",
  },
  variants: {
    size: {
      sm: { className: "text-sm" },
      md: { className: "text-base" },
      lg: { className: "text-lg" },
    },
    disabled: {
      true: { className: "opacity-50" },
    },
  },
  defaultVariants: {
    size: "sm",
  },
});

const RadioInputIcon = useStyled(RadioIcon, {
  base: {
    className: "h-5 w-5 rounded-full border-2 border-gray-200",
    rectFillClassName: "fill-white",
    rectStrokeClassName: "stroke-white",
  },
  variants: {
    checked:{
      true: { 
        className: "border-none",
        rectFillClassName: "fill-white",
        rectStrokeClassName: "stroke-teal-500",
      },
      false: {},
    }
  },
  defaultVariants: {},
});

export const RadioInput = useSlot(RadioInputRoot, {
  Label: RadioInputLabel,
  Icon: RadioInputIcon,
});


